import React from 'react';
import { VscSearch } from 'react-icons/vsc';
import { AiOutlineClose } from 'react-icons/ai';
import Bouton from '../Bouton/Bouton';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import styles from './SearchBar.module.scss';

const SearchBar = ({
  searchValue,
  onChange,
  onClear,
  placeholder = 'recherche',
}) => {
  return (
    <div className={styles.searchBar}>
      <Bouton type={type_btn.outil} rond cliquer={onClear}>
        {searchValue ? <AiOutlineClose size={15} /> : <VscSearch size={15} />}
      </Bouton>
      <input
        type="text"
        placeholder={checkMot(placeholder)}
        value={searchValue}
        onChange={onChange}
        className={styles.searchInput}
      />
    </div>
  );
};

export default SearchBar;
